import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTitle } from '../../common/hooks';
import './AccountHaveNoAccessPage.scss';

const AccountHaveNoAccessPageImpl: React.FC = () => {

  useTitle('No Access');

  return (
    <main className='account-have-no-access-page'>
      <h1>Access denied</h1>
      <p>We’re sorry. The account you are attempting to log in with does not have access to the required page. You must be a registered Microsoft Partner to see the Partner of the Year Award site. Please talk to your Microsoft AI Cloud Partner Program Admin.</p>
      <p>
        <a href='https://partner.microsoft.com/en-us/membership/'>Learn how to become a Microsoft Partner</a>
      </p>
    </main>
  );
}

export const AccountHaveNoAccessPage = observer(AccountHaveNoAccessPageImpl);
